import { createTheme } from "@mui/material";

export const COLOR_PRIMARY = "#296bd6";
export const COLOR_SECONDARY = "#4c4d52";
export const COLOR_WHITE = "#FFFFF";
export const THEME = createTheme({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          fontFamily: `"Poppins", sans-serif`
        }
      }
    }
  },
  typography: {
    fontFamily: `"Poppins", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600
  },
  mixins: {
    toolbar: {
      backgroundColor: COLOR_WHITE,
      fontSize: "13px"
    }
  },
  palette: {
    // text: {
    //   primary: COLOR_PRIMARY,
    // },
    primary: {
      main: COLOR_PRIMARY
    },
    secondary: {
      main: COLOR_WHITE
    }
  }
});
